<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
    <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
      <v-flex xs12 md10 v-else>
        <v-card class="elevation-1">
          
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">{{ plan.insurancePlan.name }}</v-toolbar-title>
          </v-toolbar>
              <v-card-title>
                <v-container fluid>
                  <v-layout>
                    <v-flex xs2>
                      <v-subheader>Short name:</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                        <v-subheader>
                        {{plan.insurancePlan.short_name}}
                        </v-subheader> 
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs2>
                      <v-subheader>Name:</v-subheader>
                    </v-flex>
                    <v-flex xs5>
                         <v-subheader>
                        {{plan.insurancePlan.name}}
                        </v-subheader> 
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <table>
                        <thead>
                          <tr>
                            <th>Period up to </th>
                            <template v-for="ages in plan.insurancePlan.pricing">
                              <th :key="ages">{{ ages.begin }} to {{ ages.end }} years</th>
                            </template>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(duration, index) in plan.insurancePlan.pricing[0].pricing">
                            <tr :key="index" style>
                              <th>{{ duration.duration }} days</th>
                              <template v-for="(cena, secondIndex) in plan.insurancePlan.pricing">
                                <td class="text-xs-center" type="text" :key="secondIndex+index">{{ plan.insurancePlan.pricing[secondIndex].pricing[index].price }}</td>
                              </template>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-container>
            </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
export default {
  components: {
    Spinner
  },
  data() {
    return {
      dataLoading: true,
      plan: {},
     
    }
  },
  mounted: function() {
    this.getPlan();
  },
  methods: {
    goBack(){
      this.$router.push("/admin/plans");
    },
    getPlan() {
      axios.get("/insuranceplans/" + this.$route.params.id).then(res => {
        this.dataLoading = false
        this.plan = res.data;
      });
    },
    post() {
      axios.put("/insuranceplans/" + this.$route.params.id, this.plan).then(res => {
      });
    }
  }
};
</script>

<style scoped>
    .table {
        background: #e7e7e8;
        width: auto;
        table-layout: fixed
    }

    .table th {
        font-weight: 400;
        padding-right: 30px !important;
        background: none
    }

    .table td {
        font-weight: 700;
        min-width: 200px
    }

    .table>thead>tr>th,.table>tbody>tr>th,.table>tfoot>tr>th,.table>thead>tr>td,.table>tbody>tr>td,.table>tfoot>tr>td {
        border-top: none;
        padding: 5px 10px
    }

    .table,.table tr+tr {
        border: none
    }

    .table .empty-cell {
        height: 30px
    }

    .table tr:nth-child(even) {
        background: #d1d2d4
    }

    table {
        border: 1px solid #eee
    }

    table th {
        white-space: nowrap;
        background: #e7e7e8
    }

    table th,table td {
        padding: 12px 15px;
        text-align: left
    }

    table tr+tr {
        border-top: 1px solid #eee
    }
    input {
      width: 50px !important;
      border-bottom: 1px solid grey !important;
      
    }

</style>


// WEBPACK FOOTER //
// src/components/admin/Plans/PlansShow.vue